module.exports = __webpack_public_path__ + "img/icons_ex.svg";


//////////////////
// WEBPACK FOOTER
// ./img/icons_ex.svg
// module id = 256
// module chunks = 0